import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  return {
    wrapper: {
      marginTop: theme.busbud.spacing(1)
    },
    label: {
      whiteSpace: "normal"
    },
    startIcon: {
      flexShrink: 0
    }
  };
});
